import { RouterType } from '@online-webinar/router';
import { ImportInvites } from '@online-webinar/webinar-management';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/$webinarId/invites/import'].update({
        staticData: { title: { page: 'ImportInvites.PageHeading', forWebinar: true } },
        component: authGuard(ImportInvites, { canBroadcast: true, isWhitelabel: true })
    });
};
